//
// A Fluxible store for the designs in a brief
//

import BaseStore from 'fluxible/addons/BaseStore';
import Immutable from 'immutable';

const MIN_SELECTION = 3;
const MAX_SELECTION = 10;

interface Design {
    id: number;
}

class BriefDesignStore extends BaseStore {
    static storeName = 'BriefDesignStore';
    static handlers = {
        TOGGLE_DESIGN: 'toggleDesign',
        LOAD_DRAFT_DATA: 'load',
        CLEAR_DESIGNS: 'clearDesigns',
        SAVE_DRAFT_SUCCESS: 'updateDesigns',
    };

    designs = Immutable.OrderedSet<Design>([]);
    selectedDesigns = Immutable.OrderedSet<number>([]);

    load(payload: {
        designs: Design[];
        body: {
            sample_designs: number[];
        };
    }) {
        if (payload.designs) {
            this.setDesigns(payload.designs);
        }

        if (payload.body.sample_designs) {
            this.setSelectedDesigns(payload.body.sample_designs);
        }
        this.emitChange();
    }

    updateDesigns(payload: { designs: Design[] }) {
        if (payload.designs) {
            this.setDesigns(payload.designs);
        }
        this.emitChange();
    }

    clearDesigns() {
        this.setDesigns([]);
        this.setSelectedDesigns([]);
    }

    setDesigns(designs: Design[]) {
        this.designs = Immutable.OrderedSet(designs);
    }

    setSelectedDesigns(designs: number[]) {
        this.selectedDesigns = Immutable.Set(designs);
    }

    toggleDesign(design: number) {
        if (!this.selectedDesigns.has(design)) {
            this.selectedDesigns = this.selectedDesigns.add(design);
        } else {
            this.selectedDesigns = this.selectedDesigns.delete(design);
        }
        this.emitChange();
    }

    getDesigns() {
        return this.designs;
    }

    getSelectedDesigns() {
        return this.selectedDesigns;
    }

    getPercentageComplete() {
        return this.selectedDesigns.count() / MAX_SELECTION * 100;
    }

    isSelectionDisabled() {
        return this.getPercentageComplete() >= 100;
    }

    isMinimumAmountSelected() {
        return this.selectedDesigns.count() >= MIN_SELECTION;
    }

    findDesign(id: number) {
        return this.designs.find((design: Design) => {
            return design.id === id;
        });
    }
}

export default BriefDesignStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefDesignStore.ts